import GalaxyAiAlternativePage from '@/components/Pages/GalaxyAiAlternativePage';

export default GalaxyAiAlternativePage;
